import { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { DragDropContext, Draggable } from "@hello-pangea/dnd";
import { StrictModeDroppable as Droppable } from "../../helpers/StrictModeDroppable";
import axios from '../../api/axios';
import _ from "lodash";
import styles from "./Admin.module.css";
import LoadingModal from "../LoadingModal";

const defaultStatus = "active";
const defaultType = "Benchmarking";
const statuses = [
    { display: "Active", value: "active" },
    { display: "Archived", value: "archived" },
    { display: "Deleted", value: "deleted" },
]
const types = [
    { display: "Profile", value: "Profile" },
    { display: "Benchmarking", value: "Benchmarking" },
    { display: "Insights", value: "Insights" },
    { display: "Pop-up", value: "Pop-up" },
]

const validTextRegex = /(.|\s)*\S(.|\s)*/

const EditSurvey = () => {

    const navigate = useNavigate();

    let { surveyId } = useParams();

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [status, setStatus] = useState(defaultStatus);
    const [type, setType] = useState(defaultType);
    const [surveyQuestions, setSurveyQuestions] = useState([]);
    const [insightsCategory, setInsightsCategory] = useState(null);
    const [tags, setTags] = useState("");
    const [isPrivate, setIsPrivate] = useState(false);

    const [titleCopy, setTitleCopy] = useState("");
    const [descriptionCopy, setDescriptionCopy] = useState("");
    const [statusCopy, setStatusCopy] = useState(defaultStatus);
    const [typeCopy, setTypeCopy] = useState(defaultType);
    const [surveyQuestionsCopy, setSurveyQuestionsCopy] = useState([]);
    const [insightsCategoryCopy, setInsightsCategoryCopy] = useState(null);
    const [tagsCopy, setTagsCopy] = useState("");
    const [isPrivateCopy, setIsPrivateCopy] = useState(false);

    const [insightsCategories, setInsightsCategories] = useState([]);

    const [validTitle, setValidTitle] = useState(false);

    const [isSaving, setIsSaving] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);

    const parseResponse = (response) => {
        setTitle(response.data.title);
        setDescription(response.data.description);
        setStatus(response.data.status);
        setType(response.data.type);
        setInsightsCategory(response.data.insightsCategory);
        setSurveyQuestions(_.cloneDeep(response.data.surveyQuestions));
        setTags(response.data.tags);
        setIsPrivate(response.data.private);

        setTitleCopy(response.data.title);
        setDescriptionCopy(response.data.description);
        setStatusCopy(response.data.status);
        setTypeCopy(response.data.type);
        setInsightsCategoryCopy(response.data.insightsCategory);
        setSurveyQuestionsCopy(_.cloneDeep(response.data.surveyQuestions));
        setTagsCopy(response.data.tags);
        setIsPrivateCopy(response.data.private);

        setInsightsCategories(response.data.insightsCategories);

        setIsSaving(false);
        setDataLoaded(true);

    }

    const onDeleteSurveyQuestion = (index) => {
        const deleted = (surveyQuestions[index].deleted === true ? false : true);
        setSurveyQuestions(prev => prev.with(index, { ...prev[index], deleted: deleted }));
    }
    const handleSurveyQuestionOnDragEnd = (result) => {
        if (!result?.destination) return;

        const newSurveyQuestions = _.cloneDeep(surveyQuestions);

        const [reorderedSurveyQuestion] = newSurveyQuestions.splice(result.source.index, 1);

        newSurveyQuestions.splice(result.destination.index, 0, reorderedSurveyQuestion);

        setSurveyQuestions(newSurveyQuestions);

    }
    const saveChanges = () => {
        if (surveyId === undefined) {
            saveNewSurvey();
        } else {
            saveUpdatedSurvey();
        }
    }
    const saveUpdatedSurvey = async () => {
        if (!validTitle) {
            return;
        }

        let
            displayOrder = 0;

        const surveyQuestionsToDelete = [];
        const surveyQuestionsToUpdate = [];
        const surveyQuestionsToInsert = [];

        for (let surveyQuestion of surveyQuestions) {
            if ((surveyQuestion.deleted === true) && (surveyQuestion.surveyQuestionId !== undefined)) {
                surveyQuestionsToDelete.push({ surveyQuestionId: surveyQuestion.surveyQuestionId });
            } else {
                displayOrder++;
                surveyQuestion.displayOrder = displayOrder;
                if (surveyQuestion.surveyQuestionId === undefined) {
                    surveyQuestionsToInsert.push(surveyQuestion);
                } else {
                    for (let copy of surveyQuestionsCopy) {
                        if (surveyQuestion.surveyQuestionId === copy.surveyQuestionId) {
                            if (surveyQuestion.displayOrder !== copy.displayOrder) {
                                surveyQuestionsToUpdate.push(surveyQuestion);
                            }
                        }
                    }
                }
            }
        };

        const json = {};

        json.title = title;
        json.description = description;
        json.status = status;
        json.type = type;
        json.insightsCategory = insightsCategory;
        json.tags = tags;
        json.private = isPrivate;
        json.surveyQuestionsToDelete = _.cloneDeep(surveyQuestionsToDelete);
        json.surveyQuestionsToUpdate = _.cloneDeep(surveyQuestionsToUpdate);
        json.surveyQuestionsToInsert = _.cloneDeep(surveyQuestionsToInsert);

        console.log(json);

        if (
            (title !== titleCopy) ||
            (description !== descriptionCopy) ||
            (status !== statusCopy) ||
            (type !== typeCopy) ||
            (insightsCategory !== insightsCategoryCopy) ||
            (tags !== tagsCopy) ||
            (isPrivate !== isPrivateCopy) ||
            (surveyQuestionsToDelete.length > 0) ||
            (surveyQuestionsToUpdate.length > 0) ||
            (surveyQuestionsToInsert.length > 0)
        ) {
            setIsSaving(true);
            try {
                const response = await axios.patch(`/surveys/${surveyId}`,
                    JSON.stringify(json),
                    {
                        headers: { 'Content-Type': 'application/json' }
                    }
                );
                parseResponse(response);

            } catch (err) {
                console.log(err);
                // if (!err?.response) {
                //     setErrMsg('No Server Response');
                // } else if (err.response?.status === 409) {
                //     setErrMsg('Email Taken');
                // } else {
                //     setErrMsg('Registration Failed')
                // }
                // errRef.current.focus();
            }

        }

    }
    const saveNewSurvey = async () => {
        if (!validTitle) {
            return;
        }

        const json = {};

        json.title = title;
        json.description = description;
        json.status = status;
        json.type = type;
        json.insightsCategory = insightsCategory;
        json.tags = tags;
        json.private = isPrivate;

        setIsSaving(true);

        console.log(json);

        try {
            const response = await axios.post(`/surveys`,
                JSON.stringify(json),
                {
                    headers: { 'Content-Type': 'application/json' }
                }
            );
            console.log(JSON.stringify(response?.data));

            surveyId = response.data.surveyId;

            // parseResponse(response);

            navigate(`/survey/edit/${surveyId}`, { replace: true });

        } catch (err) {
            console.log(err);
            // if (!err?.response) {
            //     setErrMsg('No Server Response');
            // } else if (err.response?.status === 409) {
            //     setErrMsg('Email Taken');
            // } else {
            //     setErrMsg('Registration Failed')
            // }
            // errRef.current.focus();
        }

        // }

    }

    const parseSurveys = (surveys) => {
        console.log(surveys);
        const insightsCategories = [];
        const uniqueCategories = {};
        for (let survey of surveys) {
            if (survey.type === "Insights") {
                const category = survey.pollCategory;
                if (uniqueCategories[category] === undefined) {
                    uniqueCategories[category] = true;
                    insightsCategories.push({ category });
                }
            }
        }
        setInsightsCategories(insightsCategories)
        setDataLoaded(true);
        setIsSaving(false);
    }

    useEffect(() => {

        // if (surveyId === undefined) {
        //     return;
        // }

        let isMounted = true;

        const controller = new AbortController();

        if (surveyId !== undefined) {
            const getSurvey = async () => {

                setIsSaving(true);

                try {
                    const response = await axios.get(`/surveys/${surveyId}`, {
                        signal: controller.signal
                    });
                    console.log(response.data);
                    if (isMounted) {
                        parseResponse(response);
                    }
                } catch (err) {
                    if (isMounted) {
                        console.error(err);
                        // if (err.response?.status === 403) {
                        //     navigate('/login', { state: { from: location }, replace: true });
                        // }
                    }
                }
            }

            getSurvey();
        } else {
            const getSurveys = async () => {

                setIsSaving(true);

                try {
                    const response = await axios.get("/surveys", {
                        signal: controller.signal
                    });
                    if (isMounted) {
                        parseSurveys(response.data);
                    }
                } catch (err) {
                    if (isMounted) {
                        console.error(err);
                        // if (err.response?.status === 403) {
                        //     navigate('/login', { state: { from: location }, replace: true });
                        // }
                    }
                }
            }

            getSurveys();

        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setValidTitle(validTextRegex.test(title));
    }, [title]);

    if (!dataLoaded) {
        return <LoadingModal />;
    }

    console.log(`EditSurvey: render at ${new Date().getTime()}`);

    return (
        <section className={styles.admin}>
            <p><Link to="/admin">Admin</Link> &gt; <Link to="/surveys">Surveys</Link> &gt; {((surveyId === undefined) ? "New survey" : title)}</p>
            <h3>Survey detail</h3>
            <label htmlFor="title">Title</label>
            <input type="text" id="title" name="title" autoComplete="off" maxLength="100" placeholder="Survey title" value={title} onChange={e => setTitle(e.target.value)} readOnly={(type === "Profile")} />
            <label htmlFor="description">Description</label>
            <textarea name="description" maxLength="500" rows={3} autoComplete="off" value={description} onChange={e => setDescription(e.target.value)} >{description}</textarea>
            <h3 className={((type === "Profile") || (type === "Pop-up")) ? "disabled" : ""}>Type:</h3>
            {
                types.map((option, i) => {
                    const isDisabled = ((type === "Profile") || (type === "Pop-up") || (option.value === "Profile") || (option.value === "Pop-up"));
                    return (
                        <div key={i} className="radio-button-and-label">
                            <input type="radio" id={option.value} name="type" value={option.value} onChange={(e) => setType(e.target.value)} checked={type === option.value} disabled={isDisabled} />
                            <label htmlFor={option.value} className={isDisabled ? "disabled" : ""}>{option.display}</label>
                        </div>
                    )
                })
            }
            {
                (type === "Insights") &&
                <>
                    <h3>Private:</h3>
                    <div className="radio-button-and-label">
                        <input type="checkbox" id="isPrivate" name="isPrivate" onChange={(e) => setIsPrivate(e.target.checked)} checked={isPrivate} />
                        <label htmlFor="isPrivate">This survey is only visible to authorized users</label>
                    </div>

                    <h3>Insights category:</h3>
                    {
                        insightsCategories.map((option, i) => {
                            console.log(option.category, insightsCategory, (insightsCategory === option.category));
                            return (
                                <div key={i} className="radio-button-and-label">
                                    <input type="radio" id={option.category} name="insightsCategory" value={option.category} onChange={(e) => setInsightsCategory(e.target.value)} checked={insightsCategory === option.category} />
                                    <label htmlFor={option.category}>{option.category}</label>
                                </div>
                            )
                        })
                    }
                    <h4 className={type !== "Insights" ? "disabled" : ""}>Insights tags:</h4>
                    <textarea disabled={type !== "Insights" ? true : false} name="tags" maxLength="500" rows={3} autoComplete="off" value={tags} onChange={e => setTags(e.target.value)} >{tags}</textarea>
                </>
            }
            <h3 className={((type === "Profile") || (type === "Pop-up")) ? "disabled" : ""}>Status:</h3>
            {
                statuses.map((option, i) => {
                    const isDisabled = ((type === "Profile") || (type === "Pop-up"));
                    return (
                        <div key={i} className="radio-button-and-label">
                            <input type="radio" id={option.value} name="status" value={option.value} onChange={(e) => setStatus(e.target.value)} checked={status === option.value} disabled={isDisabled} />
                            <label htmlFor={option.value} className={isDisabled ? "disabled" : ""}>{option.display}</label>
                        </div>
                    )
                })
            }
            {(surveyQuestions.length > 0) ? (
                <>
                    <div className="toolbar">
                        <h4>Survey questions:</h4>
                        <Link to="questions">Edit questions</Link>
                    </div>
                    <div className="dndContainer">
                        <DragDropContext onDragEnd={handleSurveyQuestionOnDragEnd}>
                            <Droppable droppableId="surveyQuestions">
                                {(provided) => (
                                    <div className="optionsGroup" {...provided.droppableProps} ref={provided.innerRef}>
                                        {
                                            surveyQuestions.map((surveyQuestion, i) => {
                                                return (
                                                    <Draggable key={i} draggableId={i.toString()} index={i}>
                                                        {(provided) => (
                                                            <div key={i} className="optionGroup" {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
                                                                {/* <input key={i} type="text" autoComplete="off" maxLength="500" placeholder={`Answer choice ${i + 1}`} disabled={surveyQuestion.deleted} value={surveyQuestion.title} onChange={e => onSurveyQuestionChange(i, e.target.value)} /> */}
                                                                <label className={(surveyQuestion.deleted ? "deleted" : (surveyQuestion.status === "archived" ? "archived" : ""))}>{surveyQuestion.text}</label>
                                                                <button className="delete" onClick={e => onDeleteSurveyQuestion(i)}></button>
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                )
                                            })
                                        }
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                        {/* <button onClick={e => onAddSurveyQuestion()} disabled={activeSurveyQuestions >= 7}>Add new answer choice</button> */}
                    </div>
                </>
            ) : (surveyId !== undefined) ? (<p><Link to="questions">Add questions</Link></p>) : null
            }
            <button disabled={!validTitle || isSaving} onClick={saveChanges}>Save changes</button>

        </section>
    );

};

export default EditSurvey;